import { usersMeQuery } from 'features/users/api/userQueries'
import { queryClient } from 'queryClient'
import { postMetricEvent } from '../api/metrics'
import { MetricEventPayloadMapping } from '../types'
import { isPublicMapUrl } from 'features/builder/paths'

export function sendMetricEvent<T extends keyof MetricEventPayloadMapping>(
  eventType: T,
  payload?: MetricEventPayloadMapping[T]
) {
  // IMPORTANT! We should use a more robust way to check if the user is logged in
  if (isPublicMapUrl()) return

  queryClient
    .executeMutation({
      mutationFn: async () => {
        const user = await queryClient.fetchQuery(usersMeQuery)
        if (!user) return
        await postMetricEvent(eventType, user, payload)
      }
    })
    // Fail silently, as we this could occur only if the user is not logged in
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    .catch(() => {})
}
